import React, { useEffect, useState } from "react";
import "./App.css";
import Analysis from "./components/analysis";
import Score from "./components/score";
import Header from "./components/header";
import Support from "./components/support";
import Footer from "./components/footer";
import EarningsAnalysis from "./components/earnings-analysis";

function gtag() {
  window.dataLayer.push(arguments);
}

function updateGoogleAnalytics() {
  window.dataLayer = window.dataLayer || [];

  gtag("js", new Date());
  gtag("title", document.title);
  gtag("pageTitle", document.title);
  gtag("config", "G-RD8TS4S07Q");
}

function App() {
  const [stockData, setStockData] = useState(null);
  const [timestamp, setTimestamp] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const hash = window.location.href
      .replace("#", "")
      .split("/")
      .filter((p) => p)
      .reverse()[0];
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://api.fomo-score.com/share/${hash}`
        );
        if (response.status !== 200) {
          throw response.status;
        }
        const data = await response.json();
        setStockData(data.data);
        setTimestamp(data.created_on);
        document.title = data.data.symbol;
        updateGoogleAnalytics();
      } catch (e) {
        setError("Record not found!");
        console.error("Error fetching JSON data", e);
      }
    };
    fetchData();
  }, []);
  return (
    <div className="App gradient-background">
      <header className="App-header">
        {stockData != null ? (
          <div className="flex w-full md:w-[950px] h-fit mx-4 md:mx-6 flex-col md:flex-row justify-center mt-6 md:mt-8">
            <div className="flex w-full md:w-1/2 md:h-full justify-normal md:justify-around flex-col px-4 md:px-6 py-4 md:py-6 gap-6 md:gap-8">
              <Header data={stockData} />
              <Score data={stockData} />
              <Support data={stockData} />
              <Footer />
              <div className="text-xs text-right text-gray-400 mt-8">
                Snapshot taken on: {timestamp}
              </div>
            </div>
            <div className="flex w-full md:w-1/2 flex-col gap-6 md:gap-8 px-4 md:px-0">
              <Analysis data={stockData.analysis} />
              {stockData.earnings_analysis ? (
                <EarningsAnalysis data={stockData.earnings_analysis} />
              ) : null}
            </div>
          </div>
        ) : error != null ? (
          <div>{error}</div>
        ) : (
          <div>Loading...</div>
        )}
      </header>
    </div>
  );
}

export default App;
